var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTransactionsIconActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 18,
    viewBox: "0 0 16 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.85547 12.9736L14.6844 12.9734",
    stroke: "#011957",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.8291 5.27637L1.00014 5.27616",
    stroke: "#011957",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.27632 8.69727L1.70711 12.2665C1.37377 12.5998 1.20711 12.7665 1.20711 12.9736C1.20711 13.1807 1.37377 13.3474 1.70711 13.6807L5.27632 17.2499",
    stroke: "#011957",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10.4078 1L13.977 4.56921C14.3103 4.90254 14.477 5.06921 14.477 5.27632C14.477 5.48342 14.3103 5.65009 13.977 5.98342L10.4078 9.55263",
    stroke: "#011957",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTransactionsIconActive);
export default __webpack_public_path__ + "static/media/transactionsIcon-active.b540df5fffbe5459f66de12346d889dd.svg";
export { ForwardRef as ReactComponent };